import React from 'react';
import { observer } from 'mobx-react';
import { LanguageMetadataTemplate } from 'themes/components';
import { useStores } from 'core/stores/StoreContext';

const LanguageMetadata = observer((props) => {
    const { localizationStore } = useStores();
    return <LanguageMetadataTemplate {...props} language={localizationStore.language} />;
});

export default LanguageMetadata;
